import type { Brand } from "@pdfking/tfunc"

export type Pointer = Brand<number, "Pointer">
